import coinProgress from './coin-progress.webp';
import contributions from './contributions.webp';
import communityJackpot from './community-jackpot.webp';
import communityJackpotHeader from './community-jackpot-header.webp';
import JackpotBag from './jackpot-bag.webp';
import flare from './flare.webp';
import JackpotFlag from './jackpot-flag.webp';
import JackpotMeter from './jackpot-meter.webp';
import JackpotSandClock from './jackpot-sandclock.webp';
import PlayNowBanner from './status-cta-banner.webp';
import FirstPhoneJackpot from './phone-1-jackpot.webp';
import SecondPhoneJackpot from './phone-2-jackpot.webp';
import ThirdPhoneJackpot from './phone-3-jackpot.webp';

import gems from './status/gems';

export default {
  ...gems,
  coinProgress,
  contributions,
  communityJackpot,
  communityJackpotHeader,
  JackpotBag,
  flare,
  JackpotFlag,
  JackpotMeter,
  JackpotSandClock,
  PlayNowBanner,
  FirstPhoneJackpot,
  SecondPhoneJackpot,
  ThirdPhoneJackpot,
};
